<template>
  <el-container class="mainWrapper">
    <el-aside style="padding: 0;" width="0vw">
      <drawer-aside :unfold="unfold" @unfoldMethod="fold($event)" />
    </el-aside>
    <el-container>
      <header-section @spread="spread" />
      <el-main style="padding: 0; overflow: visible;;margin-top: 6px;">
        <breadcrumb-account-section />
        <profile-image-section />
        <profile-details-section />
<!--        <still-have-questions />-->
        <email-us-section-light />
        <property-icon-set />
      </el-main>
      <el-footer style="padding: 0; height: 0">
        <footer-section />
      </el-footer>
    </el-container>
  </el-container>
</template>

<script>
import HeaderSection from "../package/HeaderSection.vue";
import FooterSection from "../package/footerSection.vue";
import propertyIconSet from "../package/propertyIconSet.vue";
import BreadcrumbSection from "../package/breadcrumbSection.vue";
import ProfileImageSection from "./components/profileImageSection.vue";
import WelcomeAgent from "../package/welcomeAgent.vue";
import StillHaveQuestions from "../package/stillHaveQuestions.vue";
import DrawerAside from "../package/DrawerAside.vue";
import {
  redirectToContactUs,
  redirectToHome,
  redirectToLogin
} from "../../helpers/routerHelper";

import { mapActions } from "vuex";
import BreadcrumbAccountSection from "./breadcrumbAccountSection.vue";
import ProfileDetailsSection from "./profileDetailsSection.vue";
import EmailUsSectionLight from "../contact/emailUsSectionLight.vue";

export default {
  data() {
    return {
      unfold: false,
      value1: true,
      theme: "dark",
      switchColor: "#2D2D2D",
      ipad: false,
      phone: false,
      ready: false,
      email: "",
      pswd: "",
      warn: false,
      warn2: false,
      warn3: false,
      showlogin: false,
      showforget: false,
      haveSubmit: false,
      disableLogin: true,
      disableForget: true,
      link: "",
      tenant: window.location.hostname
        .replace("m.", "")
        .split(".")[0]
        .split("testunifiproperty")[0]
        .split("unifiproperty")[0]
        .split("platform")[0]
    };
  },
  created() {
    var that = this;
    sessionStorage.clear();
    that.getUrl({ callback: that.ucallback });
    if (/iPad/i.test(navigator.userAgent)) {
      that.ipad = true;
    }
    if (/iPhone/i.test(navigator.userAgent)) {
      that.phone = true;
    }
    that.scroll({ data: true });
    // 防止页面后退
    /*history.pushState(null, null, document.URL)
    window.addEventListener('popstate', function () {
      history.pushState(null, null, document.URL)
    })*/
  },
  mounted() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    let color = this.value1 ? "#2D2D2D" : "#FFFFFF";
    document.documentElement.style.setProperty("--switch-color", color);
  },
  watch: {
    value1(newValue) {
      let color = newValue ? "#2D2D2D" : "#FFFFFF";
      document.documentElement.style.setProperty("--switch-color", color);
    }
  },
  methods: {
    ...mapActions("login", ["signIn", "forgot", "getUrl", "scroll"]),
    redirectToContactUs,
    redirectToHome,
    redirectToLogin,
    spread() {
      this.unfold = true;
    },
    fold() {
      this.unfold = false;
      console.log("this.unfold = false");
    },
    ucallback(res) {
      if (res.data.code === 0) {
        res.data.data.forEach(v => {
          if (v.type === 1) {
            this.link = v.url;
          }
        });
      }
    },
    evt() {
      if (this.link !== "") {
        window.open(this.link, "_blank");
      }
    },
    one() {
      window.open("https://team179607.typeform.com/to/WY478d");
    },
    tow() {
      window.open("https://team179607.typeform.com/to/lnvTLS");
    },
    /* 登录模块 start */
    openPop() {
      var that = this;
      that.email = "";
      that.showlogin = true;
      that.showforget = false;
      that.warn = false;
      that.warn2 = false;
    },
    // 去掉空格，判断两个输入框都有内容，按钮高亮
    handleInput() {
      var that = this;
      that.email = that.email.replace(/\s+/g, "");
      that.pswd = that.pswd.replace(/\s+/g, "");
      that.warn = false;
      if (that.email.length > 0 && that.pswd.length > 0) {
        that.disableLogin = false;
        that.warn2 = false;
        that.warn3 = false;
      } else {
        that.disableLogin = true;
      }
    },
    clean(txt) {
      var that = this;
      if (txt === "email") {
        that.email = "";
        that.warn = false;
        that.warn3 = false;
      } else if (txt === "pswd") {
        that.pswd = "";
        that.warn2 = false;
      }
      that.disableLogin = true;
    },
    validate() {
      var that = this;
      if (that.email === "") {
        that.warn = false;
        return;
      }
      var reg = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/;
      if (reg.test(that.email)) {
        that.warn = false;
      } else {
        that.warn = true;
      }
    },
    login() {
      var that = this;
      if (that.disableLogin) {
        return false;
      }
      that.$box.loadings();
      that.signIn({
        params: { email: that.email, password: that.pswd },
        callback: that.callback
      });
    },
    callback(res) {
      var that = this;
      that.$box.loadings(2);
      if (res.data.code === 0) {
        ga(
          "send",
          "event",
          "login",
          that.email,
          res.data.data.firstName + " " + res.data.data.lastName
        );
        localStorage.clear();
        // 保存token在本地
        localStorage.setItem("token", res.data.data.token);
        // 带参跳转
        localStorage.setItem("flagPass", res.data.data.flagPass);
        localStorage.setItem("flagAgreement", res.data.data.flagAgreement);
        setTimeout(() => {
          that.$router.push("/");
        }, 500);
      } else if (res.data.code === 70010) {
        that.warn2 = true;
      } else if (res.data.code === 40007) {
        that.warn = true;
      } else if (
        res.data.code === 90000 ||
        res.data.code === 90002 ||
        res.data.code === 90001
      ) {
        localStorage.clear();
        that.$router.push("/login");
      } else if (res.data.code === 8902 || res.data.code === 8901) {
        that.$box.alert("", res.data.message, "error");
        localStorage.clear();
        that.$router.push("/login");
      } else {
        that.$box.alert("", res.data.message, "error");
      }
    },
    hidelogin() {
      this.showlogin = false;
    },
    /* 登录模块 end */
    /* 忘记密码模块 start */
    toLogin() {
      var that = this;
      that.email = "";
      that.pswd = "";
      that.showlogin = true;
      that.showforget = false;
      that.haveSubmit = false;
      that.warn = false;
      that.wran2 = false;
    },
    forget() {
      var that = this;
      that.email = "";
      that.pswd = "";
      that.showlogin = false;
      that.showforget = true;
      that.haveSubmit = false;
      that.warn = false;
      that.wran2 = false;
      console.log(that.warn2);
    },
    // 去掉空格，判断两个输入框都有内容，按钮高亮
    handleInput2() {
      var that = this;
      that.email = that.email.replace(/\s+/g, "");
      if (that.email.length > 0) {
        that.disableForget = false;
        that.warn = false;
      }
    },
    hideforget() {
      this.showforget = false;
    },
    submit() {
      var that = this;
      console.log(that.warn2);
      if (that.warn2) {
        return false;
      }
      console.log(that.warn2);
      that.$box.loadings();
      that.forgot({
        params: { email: that.email },
        callback: that.forgotCallback
      });
    },
    forgotCallback(res) {
      var that = this;
      that.$box.loadings(2);
      if (res.data.code === 0) {
        that.haveSubmit = true;
      } else if (res.data.code === 40007) {
        that.$box.alert("", res.data.message, "error");
      } else if (
        res.data.code === 90000 ||
        res.data.code === 90002 ||
        res.data.code === 90001
      ) {
        localStorage.clear();
        that.$router.replace("/login");
      } else if (res.data.code === 8902 || res.data.code === 8901) {
        that.$box.alert("", res.data.message, "error");
        localStorage.clear();
        that.$router.replace("/login");
      } else {
        that.$box.alert("", res.data.message, "error");
      }
    },
    tenantClassAblute(ipad) {
      let className = "";
      if (ipad) {
        className = "ablute";
      }
      return className;
    },
    tenantClass() {
      return "tenant-" + this.tenant;
    }
    /* 忘记密码模块 end */
  },
  components: {
    EmailUsSectionLight,
    HeaderSection,
    BreadcrumbAccountSection,
    BreadcrumbSection,
    DrawerAside,
    ProfileDetailsSection,
    FooterSection,
    propertyIconSet,
    ProfileImageSection,
    WelcomeAgent,
    StillHaveQuestions
  }
};
</script>

<style lang="scss" scoped>
.mainWrapper {
  background-color: #2d2d2d;
}

.right-centered {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 16px 16px 16px 0;
}

.left-centered {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 16px 0 16px 16px;
}

.main-menu-item-style {
  padding: 30px 40px;
  background-color: #101010;
  border-bottom: 1px solid #585858;
}

.menu-item-font {
  color: #fff;
  font-feature-settings: "clig" off, "liga" off;
  font-family: Metropolis;
  font-size: 28px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.sub-menu-item-style {
  padding: 0 40px;
  background: #2d2d2d;
  //background-color: #2D2D2D;
}

.sub-item-font {
  color: #fff;
  font-feature-settings: "clig" off, "liga" off;
  font-family: Metropolis;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.centered-social-icon {
  display: flex;
  justify-content: center;
  align-items: center;
}

.left-centered {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 20px 0 20px 40px;
}

.right-centered {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 20px 16px 20px 0;
}

.light-dark-text {
  color: #dedede;
  font-feature-settings: "clig" off, "liga" off;
  font-family: Metropolis;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
}

.el-switch /deep/ .el-switch__label--left {
  color: #ffffff;
  //color: #2D2D2D;
}

.el-switch /deep/ .el-switch__label--right {
  color: #ffffff;
}

.el-switch /deep/ .el-switch__core:after {
  background-color: var(--switch-color);
}
</style>



// WEBPACK FOOTER //
// src/components/profile/profilePage.vue